import { customizeError } from '@chilecompra/react-kit'
import { isBefore } from 'date-fns'
import { makeActionCreator } from '../../config/store/utils'
import { REACT_APP_FEATURE_FLAG_REASON_ANTIUNION_PRACTICES } from '../../config/settings/environment'
import { ANTIUNION_PRACTICES, DISABILITY_REASONS } from '../../config/settings/constant'
import { checkIfForeignDni } from '../../modules/utils/helpers'
import {
  addingToWaitingListRecalculate,
  getHabilityDetailList,
  validateButtonRecalculate
} from '../../services/enrollmentCertificate'

export const GET_ABILITY_STATUS_DETAIL = 'GET_ABILITY_STATUS_DETAIL'
export const GET_ABILITY_STATUS_DETAIL_ERROR = 'GET_ABILITY_STATUS_DETAIL_ERROR'
export const GET_ABILITY_STATUS_DETAIL_SUCCESS = 'GET_ABILITY_STATUS_DETAIL_SUCCESS'
export const onGetAbilityStatusDetail = makeActionCreator(GET_ABILITY_STATUS_DETAIL)
export const onGetAbilityStatusDetailError = makeActionCreator(GET_ABILITY_STATUS_DETAIL_ERROR, 'payload')
export const onGetAbilityStatusDetailSuccess = makeActionCreator(GET_ABILITY_STATUS_DETAIL_SUCCESS, 'payload')
export const onGetAbilityStatusDetailThunk = payload => async (dispatch, getState) => {
  dispatch(onGetAbilityStatusDetail())

  try {
    const { abilityStatus } = getState().basicSellerInformation
    const mustShowAntiUnionPractices = isBefore(new Date(REACT_APP_FEATURE_FLAG_REASON_ANTIUNION_PRACTICES), new Date())

    // If the user type is 'Comprador', I can avoid calling the endpoint if the seller ability status is 'HABIL'
    if (payload.userType === 'Comprador' && (abilityStatus === 'HABIL' || abilityStatus === 'SIN INFORMACIÓN')) {
      return dispatch(
        onGetAbilityStatusDetailSuccess({
          abilityStatus,
          abilityDetails: Object.values(DISABILITY_REASONS).map(reason => {
            return {
              key: reason.key,
              title:
                mustShowAntiUnionPractices && reason.key === 'PRÁCTICAS ANTISINDICALES'
                  ? ANTIUNION_PRACTICES[reason.key].title
                  : reason.title,
              subtitle:
                mustShowAntiUnionPractices && reason.key === 'PRÁCTICAS ANTISINDICALES'
                  ? ANTIUNION_PRACTICES[reason.key].subtitle
                  : reason.subtitle,
              description:
                mustShowAntiUnionPractices && reason.key === 'PRÁCTICAS ANTISINDICALES'
                  ? ANTIUNION_PRACTICES[reason.key].positive
                  : reason.positive,
              status: true
            }
          })
        })
      )
    }

    const isForeign = checkIfForeignDni(payload.dni)
    const { data } = await getHabilityDetailList({
      actionType: GET_ABILITY_STATUS_DETAIL,
      dni: payload.dni,
      isForeign: isForeign ? 1 : 0
    })

    const abilityDetails = data.payload?.habilidadList?.map(reason => {
      return {
        key: DISABILITY_REASONS[reason.tipoHabilidad.toUpperCase()].key,
        title:
          mustShowAntiUnionPractices && reason.tipoHabilidad.toUpperCase() === 'PRÁCTICAS ANTISINDICALES'
            ? ANTIUNION_PRACTICES[reason.tipoHabilidad.toUpperCase()].title
            : DISABILITY_REASONS[reason.tipoHabilidad.toUpperCase()].title,
        subtitle:
          mustShowAntiUnionPractices && reason.tipoHabilidad.toUpperCase() === 'PRÁCTICAS ANTISINDICALES'
            ? ANTIUNION_PRACTICES[reason.tipoHabilidad.toUpperCase()].subtitle
            : DISABILITY_REASONS[reason.tipoHabilidad.toUpperCase()].subtitle,
        description:
          mustShowAntiUnionPractices && reason.tipoHabilidad.toUpperCase() === 'PRÁCTICAS ANTISINDICALES'
            ? ANTIUNION_PRACTICES[reason.tipoHabilidad.toUpperCase()][reason.estadoHabilidad ? 'positive' : 'negative']
            : DISABILITY_REASONS[reason.tipoHabilidad.toUpperCase()][reason.estadoHabilidad ? 'positive' : 'negative'],
        status: reason.estadoHabilidad
      }
    })

    return dispatch(
      onGetAbilityStatusDetailSuccess({
        abilityStatus,
        abilityDetails
      })
    )
  } catch (error) {
    // FIXME: this checks should goes inside the factoryService implementation.
    // It will be fixed in v2 of react-kit.
    if (error?.originalError?.code === 'ERR_CANCELED') {
      return
    }

    let reason
    switch (error.code) {
      case 401:
        reason = 'UNAUTHORIZED_ERROR'
        break
      case 403:
        reason = 'FORBIDDEN_ERROR'
        break
      default:
        reason = 'SOMETHING_WENT_WRONG_ERROR'
        break
    }

    return dispatch(
      onGetAbilityStatusDetailError({
        error: customizeError({ originalError: error?.originalError, code: error.code, reason }).toObject()
      })
    )
  }
}

export const GET_VALIDATE_RECALCULATE_BUTTON = 'GET_VALIDATE_RECALCULATE_BUTTON'
export const GET_VALIDATE_RECALCULATE_BUTTON_ERROR = 'GET_VALIDATE_RECALCULATE_BUTTON_ERROR'
export const GET_VALIDATE_RECALCULATE_BUTTON_SUCCESS = 'GET_VALIDATE_RECALCULATE_BUTTON_SUCCESS'
export const onGetValidateRecalculateButton = makeActionCreator(GET_VALIDATE_RECALCULATE_BUTTON)
export const onGetValidateRecalculateButtonError = makeActionCreator(GET_VALIDATE_RECALCULATE_BUTTON_ERROR, 'payload')
export const onGetValidateRecalculateButtonSuccess = makeActionCreator(
  GET_VALIDATE_RECALCULATE_BUTTON_SUCCESS,
  'payload'
)
export const onGetValidateButtonRecalculateThunk = payload => async dispatch => {
  dispatch(onGetValidateRecalculateButton())

  try {
    const { data } = await validateButtonRecalculate({
      actionType: GET_VALIDATE_RECALCULATE_BUTTON,
      dni: payload.dni
    })

    if (data && data.success === 'OK') {
      const horasRecalculo = data.payload.horasRecalculo || 0
      return dispatch(
        onGetValidateRecalculateButtonSuccess({
          dateNextRecalculate: data.payload.fechaProximoRecalculo,
          canRecalculate: data.payload.puedeRecalcular === true ? data.payload.puedeRecalcular : false,
          recalculateHours: horasRecalculo !== 0 ? data.payload.horasRecalculo : 3
        })
      )
    }
  } catch (error) {
    return dispatch(
      onGetValidateRecalculateButtonError({
        error: customizeError({
          originalError: error?.name || 'error',
          code: error?.code || 500,
          reason: error?.reason || 'SOMETHING_WENT_WRONG_ERROR_RECALCULATE'
        }).toObject()
      })
    )
  }
}

export const SET_WAITING_LIST_RECALCULATE_PROCESS = 'SET_WAITING_LIST_RECALCULATE_PROCESS'
export const SET_WAITING_LIST_RECALCULATE_PROCESS_ERROR = 'SET_WAITING_LIST_RECALCULATE_PROCESS_ERROR'
export const SET_WAITING_LIST_RECALCULATE_PROCESS_SUCCESS = 'SET_WAITING_LIST_RECALCULATE_PROCESS_SUCCESS'
export const onSetWaitingListRecalculateProcess = makeActionCreator(SET_WAITING_LIST_RECALCULATE_PROCESS)
export const onSetWaitingListRecalculateProcessError = makeActionCreator(
  SET_WAITING_LIST_RECALCULATE_PROCESS_ERROR,
  'payload'
)
export const onSetWaitingListRecalculateProcessSuccess = makeActionCreator(
  SET_WAITING_LIST_RECALCULATE_PROCESS_SUCCESS,
  'payload'
)
export const onSetWaitingListRecalculateProcessThunk = payload => async dispatch => {
  dispatch(onSetWaitingListRecalculateProcess())

  try {
    const data = await addingToWaitingListRecalculate({
      actionType: SET_WAITING_LIST_RECALCULATE_PROCESS,
      dni: payload.dni
    })
    if (data && data.success === 'OK') {
      return dispatch(
        onSetWaitingListRecalculateProcessSuccess({
          canRecalculate: false,
          dateNextRecalculate: new Date(Date.now() + 3 * 60 * 60 * 1000)
        })
      )
    }
    dispatch(onGetValidateButtonRecalculateThunk({ dni: payload.dni }))
  } catch (error) {
    return dispatch(
      onSetWaitingListRecalculateProcessError({
        error: customizeError({
          originalError: error?.name || 'error',
          code: error?.code || 500,
          reason: error?.reason || 'SOMETHING_WENT_WRONG_ERROR_WAITING_LIST'
        }).toObject()
      })
    )
  }
}
